import React from 'react';
import axios from 'axios';
import {Accion} from '../comun/Index';

class Punto extends React.Component {
  constructor(props) {
    super(props);
    this.state = {}
  }

  componentDidMount(){}

  getColor(estado,seleccionado,id){
    //datos.estado === "RESUELTO" ? "#2F968B" : seleccionado === datos.persona.id ? "lightblue" : null
    if (estado === "RESUELTO")
      return("#2F968B");
    if (estado === "NO ATIENDE")
      return("#F2AF4B");
    return('white');
  }

  render(){
    const {datos, seleccionar, seleccionado} = this.props;
    return(
      <div
        style={{
          width:'100%', padding:10,
          display:'flex', flexDirection:'column', position:'relative',
          backgroundColor: this.getColor(datos.estado,seleccionado,datos.persona.id)
        }}
      >
        <div style={{position:'absolute', right:30, display:'flex', flexDirection:'row'}}>
          <Accion
            icono="pin_drop"
            ayuda="Ubicar"
            backgroundColor="#1AABB9"
            disabled={false}
            onClick={() => this.props.seleccionarPersona(datos.estado === "RESUELTO")}
          />
          <Accion
            icono="phone_enabled"
            ayuda="Atendió"
            backgroundColor="green"
            disabled={datos.estado === "RESUELTO"}
            onClick={() => this.props.atiende()}
          />
          <Accion
            icono="phone_disabled"
            ayuda=""
            backgroundColor="red"
            disabled={datos.estado === "RESUELTO"}
            onClick={() => this.props.noAtiende()}
          />
        </div>
        <div style={{paddingRight:120, display:'flex', flexDirection:'column'}}>
          <span>
            <strong>{datos.persona.documento} - </strong>
            {datos.persona.apellidos + ", " + datos.persona.nombres}
          </span>
          <strong>
          {datos.persona.localidad + " - " + datos.persona.calle + " " + datos.persona.numero}
          </strong>
        </div>
      </div>
    );
  }
}

export default class Rutas extends React.Component {
  constructor(props) {
    super(props);
    this.state={
      ruta:[]
    }
  }

  componentDidMount(){
    this.setState({ruta:this.props.ruta})
  }

  eliminar(id){
    if (window.confirm("¿Seguro desea eliminar punto de ruta?")){
      let ruta = JSON.parse(JSON.strigify(this.state.ruta));
      ruta.splice(ruta.findIndex(item => item.id === id), 1);
      this.setState({ruta});
    }
  }

  render(){
    const {ruta} = this.props;
    return(
      <div className="Todo Index" style={{width:'95%', marginTop:0, paddingTop:0}}>
        <div style={{
          width:'100%', display:'flex', flexDirection:'column',
          borderWidth:1, borderRadius:10, backgroundColor:'#ccc2b8', color:'black',
          overflowX:'hidden', height:500, overflowY:'scroll'
        }}>
          {ruta.length !== 0 && ruta.map((item, index) => {
            return(
              <span key={index}>
                <Punto
                  datos={item}
                  seleccionarPersona={(soloUbicacion) => this.props.seleccionarPersona(item.persona,item.id, soloUbicacion)}
                  atiende={() => this.props.atiende(item.id)}
                  noAtiende={() => this.props.noAtiende(item.id)}
                />
                {ruta.length - 1 !== index &&
                  <hr style ={{margin:0, padding:0, color:'lightgrey'}}/>
                }
              </span>
            )
          })}
          {ruta.length === 0 &&
            <div
              style={{
                width:'100%', padding:10, cursor:'pointer',
                display:'flex', flexDirection:'row',
              }}
            >
              <span><strong>Sin ruta asignada</strong></span>
            </div>
          }
        </div>
      </div>
    );
  }
}
